import { jsx } from "react/jsx-runtime";
const ArrowIosLeft = ({ className, color: colorProp = '#181B32', size = 32, ignoreColor })=>{
    const color = ignoreColor ? void 0 : colorProp;
    return /*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ jsx("path", {
            d: "M13.829 19a.998.998 0 0 1-.78-.373l-4.828-6a1 1 0 0 1 .01-1.267l5-6a1 1 0 1 1 1.536 1.28l-4.474 5.371 4.315 5.362a1 1 0 0 1-.78 1.627Z",
            fill: color
        })
    });
};
const outline_ArrowIosLeft = ArrowIosLeft;
export default outline_ArrowIosLeft;
